import { ActionIcon, Box, Image, Text, Tooltip } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import commonStyles from '@theme/common.module.css';
import { ReactElement } from 'react';

interface MessageInputImagePreviewProps {
  file: File;
  index: number;
  onRemove: (index: number) => void;
}

export function MessageBoxImagePreview({ file, index, onRemove }: MessageInputImagePreviewProps): ReactElement {
  return (
    <Box
      key={index}
      style={{
        position: 'relative',
        display: 'inline-block',
        borderRadius: '8px',
        overflow: 'hidden',
        border: '2px solid #20c997',
      }}
    >
      <Image
        src={URL.createObjectURL(file)}
        alt={file.name}
        style={{
          width: '80px',
          height: '80px',
          objectFit: 'cover',
        }}
      />
      <Tooltip label="Remove image" openDelay={400} bg="green.8">
        <ActionIcon
          size="xs"
          onClick={() => onRemove(index)}
          variant="default"
          style={{
            position: 'absolute',
            top: '4px',
            right: '4px',
            borderRadius: '50%',
            transition: 'all 0.2s ease',
          }}
          className={commonStyles.IconWrapper}
        >
          <IconX size={12} />
        </ActionIcon>
      </Tooltip>
      <Box
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          color: 'white',
          padding: '2px 4px',
        }}
      >
        <Text size="xs" truncate>
          {file.name}
        </Text>
      </Box>
    </Box>
  );
}
